import { Organization } from '@oolio-group/domain';
import theme from '../common/theme';

/**
 * The organization owns the "Powered by Oolio" attribution, set from the
 * accounts portal. The flag is absent until the organization sync completes and
 * on an organization that predates the setting, so the attribution stays
 * visible unless the setting is explicitly off.
 */
export const shouldShowAttribution = (
  organization?: {
    showOolioBranding?: Organization['showOolioBranding'] | null;
  } | null,
): boolean => organization?.showOolioBranding !== false;

export const DEFAULT_BRAND_COLOR = theme.palette.deepPurple;

export const resolveBrandColor = (brandColor?: string | null): string =>
  brandColor?.trim() ? brandColor : DEFAULT_BRAND_COLOR;
